import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as actions } from "../store/modules/stores";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ElevationScroll from "../components/ElevationScroll";
import { CardActionArea } from "@material-ui/core";
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  root: {
    display: "flex"
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8)
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
    borderBottom: "1px solid #e9ecef"
  },
  cardContent: {
    flexGrow: 1
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6)
  }
});

class Stores extends Component {
  initialize = async () => {
    const { actions } = this.props;
    const { id } = this.props.match.params;
    
    await actions.getStores(id);
    actions.setCustomerId(id);
  };

  componentDidMount() {
    this.initialize();
  }

  handleNext = owner => {
    const { customerId } = this.props;
    const url = `/@${customerId}/${owner}`;
    this.props.history.push(url);
  };

  render() {
    const classes = this.props.classes;
    const { stores, customerId, t } = this.props;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <ElevationScroll {...this.props}>
          <AppBar position="relative">
            <Toolbar>
              <Typography variant="h6" color="inherit" noWrap>
                First stamp
              </Typography>
            </Toolbar>
          </AppBar>
        </ElevationScroll>
        <main>
          <Container className={classes.cardGrid}>
            {stores.length == 0 && customerId.legnth != 0 && (
              <Typography variant="h6" color="inherit">
                {t("empty_store")}
              </Typography>
            )}
            {stores.length > 0 && (
              <Grid container spacing={4}>
                {stores.map(store => (
                  <Grid item key={store.owner} xs={12}>
                    <Card className={classes.card}>
                      <CardActionArea>
                        <CardMedia
                          className={classes.cardMedia}
                          image={"data:image/png;base64," + store.business_card}
                          title="Image title"
                        />
                        <CardContent className={classes.cardContent}>
                          <Typography variant="h6" component="h6">
                            {store.name}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                      <CardActions>
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => this.handleNext(store.owner)}
                        >
                          {t("store_detail_btn")}
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </Container>
        </main>
      </Container>
    );
  }
}

export default connect(
  state => ({
    customerId: state.stores.customerId,
    stores: state.stores.stores
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(withStyles(styles)(withTranslation()(Stores)));
